import { LOGIN, REFRESH_TOKEN, UPDATE_PROFILE } from 'redux/actions/types';
import { setCookie } from 'utils/cookie';
import { login, refreshToken } from 'requests/auth';
import { updateProfile } from 'requests/profile';

// thunk logic: https://redux.js.org/usage/writing-logic-thunks

export const loginAction = (data) => (dispatch) => {
    return new Promise(async (resolve, reject) => {
        try {
            const response = await login(data);
            dispatch({ type: LOGIN, payload: response.data });
            setCookie(process.env.REACT_APP_TOKEN_NAME, response.data.accessToken, 7);
            resolve(response.data);
        } catch (err) {
            reject(err);
        }
    });
};

export const refreshTokenAction = (data) => (dispatch) => {
    return new Promise(async (resolve, reject) => {
        try {
            const response = await refreshToken();
            dispatch({ type: REFRESH_TOKEN, payload: response.data });
            setCookie(process.env.REACT_APP_TOKEN_NAME, response.data.accessToken, 7);
            resolve(response.data);
        } catch (err) {
            reject(err);
        }
    });
};

export const updateProfileAction = (data) => (dispatch) => {
    return new Promise(async (resolve, reject) => {
        try {
            const response = await updateProfile(data);
            dispatch({ type: UPDATE_PROFILE, payload: response.data });
            resolve(response.data);
        } catch (err) {
            reject(err);
        }
    });
};
